import React, { useEffect } from 'react';
import { Layout, AdBlock, AdImage } from '../../components';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import "./ComoFuncionaPrestadores.scss";

const ComoFuncionaPrestadores = () => {

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <Layout background="#1f2024">
            <div className="how-to-users">
                <div className="how-to-users__container">
                    <div className="how-to-users__content">
                        <h2 className="how-to-users__content--title">¿Cómo funciona Solucionarte para los prestadores?</h2>
                        <p>
                            Te registras, completas el perfil, eliges un plan y accedes a consultas de potenciales clientes. Aceptas las que te interesan, envías una propuesta y te contratan de forma directa, sin comisiones ni intermediación.
                        </p>

                        <h4>Si eres prestador:</h4>
                        <ul>
                            <li>Completas tu perfil con fotos y detalles de tus servicios.</li>
                            <li>Recibes consultas o evalúas proyectos en cartelera.</li>
                            <li>Aceptas aquellos proyectos que te interesen y rechazas los que no.</li>
                            <li>Acuerdas precio y trabajo directamente con el cliente.</li>
                        </ul>

                        <h4>Razones para registrarte</h4>
                        <ul>
                            <li>Promover tus servicios entre quienes los están necesitando.</li>
                            <li>Balancear la cantidad de trabajo y evitar la estacionalidad.</li>
                            <li>Crear y gestionar una cartera de clientes propios.</li>
                            <li>Recibir un precio justo, basado en reputación y experiencia.</li>
                            <li>Interactuar con otros colegas.</li>
                            <li>Recibir capacitaciones.</li>
                        </ul>

                        <p>Puedes completar tus datos básicos para iniciar el proceso de registro.
                            Se te enviarán instrucciones a tu casilla de email para completar el proceso de registro de tu perfil profesional.</p>

                        <button>INICIAR REGISTRO</button>

                        <h3>Preguntas precuentes</h3>

                        <h4>¿Cómo me registro?</h4>
                        <p>Ingresas a <span>wwww.solucionarte.ar</span> y creas tu perfil. Completas los datos solicitados, los cuales luego serán revisados para su aprobación.</p>

                        <h4>¿Cómo tengo que hacer para llegar a más clientes?</h4>
                        <p>Suscribiéndote a cualquiera de nuestros planes. Con ellos te garantizarás una determinada cantidad de consultas / proyectos en los que participar. De cómo respondas, de tu reputación y perfil dependerá que conviertas las consultas, en clientes.</p>

                        <h4>¿Qué son las Consultas?</h4>
                        <p>Son los pedidos de presupuesto de los potenciales clientes. Se te avisará por email cuando tienes una nueva, o bien puedes acceder a la plataforma y revisar otras consultas disponibles.</p>

                        <h4>¿Qué información contienen las Consultas?</h4>
                        <p>Indican el tipo de servicio requerido, una descripción del problema, la zona del trabajo, los datos del cliente y si es un cliente Verificado, Frecuente o Recomendado. Una vez que aceptas la consulta, envías una propuesta y el cliente puede chatear contigo libremente.</p>

                        <h4>¿Qué datos obtendré del cliente?</h4>
                        <p>El nombre, zona de trabajo y el email. También es frecuente que provean su número de teléfono, aunque no es un requisito del sistema. Por razones de respeto a la privacidad los datos completos están disponibles a partir de que el cliente lee tu respuesta.</p>

                        <h4>¿Qué puedo esperar de la plataforma?</h4>
                        <p> <span>www.solucionarte.ar</span> es un espacio que une a la demanda con la oferta de servicios para el hogar. Todos los clientes que generan consultas tienen necesidades reales, pero convertirlas en contrataciones depende de tu perfil, tu reputación, tus precios y de como respondas. Una vez que ganas experiencia, se torna aún más sencillo y puedes concretar en promedio 1 trabajo cada 5 propuestas que pasas.</p>

                        <h4>¿Con quién cierro las contrataciones y quién me paga?</h4>
                        <p>Las cierras directamente con el cliente, que será quién te pague el 100% del servicio. <span>www.solucionarte.ar</span> no cobra ningún tipo de comisión.</p>

                        <h4>¿Y si hay consultas que no me interesan?</h4>
                        <p>Simple. Las rechazas.</p>

                        <h4>¿Es necesario poner una foto personal?</h4>
                        <p>En un mundo cada vez más anónimo, los clientes valoran tener la oportunidad de poner un rostro a ese profesional que podrían contratar. Una cara sonriente aumenta la confianza, y la confianza es clave para decidir una contratación.</p>

                        <h4>¿Por cuánto tiempo están disponibles las consultas?</h4>
                        <p>Depende del tiempo que define el cliente. Puede ser de 24 hrs a 1 semana. Varia según si es una urgencia, o bien una trabajo importante que requiere más análisis.</p>

                        <h4>¿Por qué son importantes las calificaciones?</h4>
                        <p>Básicamente, porque son el principal parámetro que tienen los clientes para decidir si contratarte. A mejor reputación, mayor cantidad de contrataciones. A los pocos días el sistema le recordará al cliente que te califique, pero en caso que quieras hacerlo antes, puedes invitarlo a calificar desde Panel de Control Mi Reputación.</p>

                        <h4>¿Qué son los Planes?</h4>
                        <p>Son paquetes de créditos que te permiten acceder a un volumen constante de trabajos en los que participar.</p>

                        <h4>¿De qué manera puedo pagar por un plan?</h4>
                        <p>Tienes dos formas de pagar:</p>

                        <ol>
                            <li>Con suscripción de renovación automática, cuando tus créditos llegan a cero.</li>
                            <li>Con pago por única vez.</li>
                        </ol>

                        <p>Dentro de la opción de pago por única vez, puedes:</p>

                        <ol>
                            <li>Pagar con tarjeta de crédito.</li>
                            <li>Pagar en efectivo.</li>
                        </ol>

                        <p>Si eliges la segunda opción (pago en efectivo), sólo tienes que imprimir el cupón e ir a la sucursal de la entidad de cobro que hayas seleccionado. Si no puedes imprimirlo, también sirve que lo lleves en el celular.</p>
                    </div>

                    <div className="how-to-users__ads">
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>

                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        <AdBlock>
                            <AdImage width="300px" height="250px" />
                        </AdBlock>
                        
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ComoFuncionaPrestadores;
